'use strict';

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */
/* global XMLHttpRequest, ActiveXObject */

function getXHR() {
    try {
        return new XMLHttpRequest();
    } catch (e) {}
    try {
        return new ActiveXObject('MSXML2.XMLHTTP');
    } catch (e) {}
    try {
        return new ActiveXObject('Microsoft.XMLHTTP');
    } catch (e) {}
    throw 'XHR not supported!';
}

module.exports = getXHR();


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-net/xhr.js
 ** module id = 16
 ** module chunks = 0 1
 **/